import { getUrlParamByName } from '@/utils/common'

const _tokenUrlKey = 'token'
const _tokenCookieKey = 'accessToken'
const _tokenStorageKey = 'accessToken'

/**
 * 通过url获取token
 */
function _getTokenByUrl() {
  return getUrlParamByName(_tokenUrlKey) || ''
}

/**
 * 通过cookie获取token
 */
function _getTokenByCookie() {
  // const accessToken = document.cookie.match(/(?:^|;)\s*accessToken=([^;]+)/)[1]
  let token = ''
  try {
    const cookies = document.cookie.split(';')
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim()
      if (cookie.indexOf(`${_tokenCookieKey}=`) === 0) {
        token = cookie.substring(`${_tokenCookieKey}=`.length, cookie.length)
        break
      }
    }
  } catch (e) {
    console.log(e)
  }
  return token
}

/**
 * 初始化用户token
 */
function accessTokenInit() {
  let token = _getTokenByUrl()
  const tokenWithCookie = _getTokenByCookie()
  if (tokenWithCookie) {
    token = tokenWithCookie
  }
  if (token) {
    window.localStorage.setItem(_tokenStorageKey, token)
  }
}

export { accessTokenInit }
